// import moment from 'moment'
import storeCart2 from '@/cartCache.js'

export default {
  computed: {
    cartEmpty () {
      if (storeCart2.state.initialized === 0 && this.user && this.isFullLogged) {
        this._getCart(true)
      }
      return !this.cartLength
    },
    cart2 () {
      if (storeCart2.state.initialized === 0 && this.user && this.isFullLogged) {
        this._getCart(true)
      }
      return this.user ? storeCart2.state.cart : {}
    },
    cartLength () {
      /* if (storeCart2.state.initialized === 0 && this.isFullLogged) {
        this._getCart(true)
      }
      return storeCart2.state.cart.OrderItemWebApi ? storeCart2.state.cart.OrderItemWebApi.length : 0 */
      return this.cart2.OrderItemWebApi ? this.cart2.OrderItemWebApi.length : 0
    },
    cartLengthLabel() {
      return this.cartLength > 9 ? '9+' : this.cartLength
    },
    cartItems () {
      return this.cart2 && this.cart2.OrderItemWebApi ? this.cart2.OrderItemWebApi : []
    },
    cartType () {
      return this.isEticketCart ? 'eticket' : 'csc'
    },
    isEticketCart () {
      if (this.cartItems.length) {
        return this.cartItems[0].MediaType.toLowerCase() === 'eticket' ? true : false
      }
      return undefined
    },
    isCscCart () {
      if (this.cartItems.length) {
        return this.cartItems[0].MediaType.toLowerCase() === 'csc' // && this.cartItems[0].MediaSerialNumber ? true : false
      }
      return undefined
    },
    cartLoading () {
      return storeCart2.state.initialized === 1
    }
  },
  methods: {
    _getCart (update) {
      if (!(this.user && this.user.Token)) {
        return new Promise((resolve /*, reject */) => {
          storeCart2.commit('updateCart', { TotalCashAmount: 0, OrderItemWebApi: [] })
          resolve()
        })
      } else {
        if (update || storeCart2.state.initialized === 0) {
          storeCart2.commit('setInitialization', 1)
          return this.$http.get('sales/getbasket', this.completeHttpParams({ headers: { userCode: this.user.UserAccountCode }})).then(response => {
            storeCart2.commit('updateCart', response.body || { TotalCashAmount: 0, OrderItemWebApi: [] })
            storeCart2.commit('setInitialization', 2)
            return storeCart2.state.cart
          }).catch(err => {
            storeCart2.commit('setInitialization', 0)
            return err
          })
        } else {
          return Promise.resolve(storeCart2.state.cart)
        }
      }
    }
  }
}